
import { AUTH_TOKEN, REFRESH_TOKEN } from './constants';
import { BACKEND_URL } from './config';

interface AuthProvider {
  username: null | string;
  isAuthenticated(): boolean;
  signin(token: string, refreshToken: string): Promise<void>;
  signout(): Promise<void>;
}

// Best-effort server-side revocation. Uses a raw fetch (not the Apollo client) to
// avoid a circular import, and never throws — local logout must proceed regardless.
// 'Logout' is auth-bypassed server-side, so it works even with an expired token.
const revokeRefreshToken = async (refreshToken: string) => {
  try {
    await fetch(BACKEND_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        operationName: 'Logout',
        query: 'mutation Logout($refreshToken: String!) { logout(refreshToken: $refreshToken) }',
        variables: { refreshToken },
      }),
    });
  } catch {
    // ignore — revocation is best-effort
  }
};

export const authProvider: AuthProvider = {
  isAuthenticated() {
    const token = localStorage.getItem(AUTH_TOKEN);
    return token != null;
  },
  username: null,
  async signin(token: string, refreshToken: string) {
    localStorage.setItem(AUTH_TOKEN, token);
    localStorage.setItem(REFRESH_TOKEN, refreshToken);
  },
  async signout() {
    const refreshToken = localStorage.getItem(REFRESH_TOKEN);
    if (refreshToken) {
      await revokeRefreshToken(refreshToken);
    }
    localStorage.removeItem(AUTH_TOKEN);
    localStorage.removeItem(REFRESH_TOKEN);
  },
};
